/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon3IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon3Icon(props: Icon3IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 28 28"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <mask
        id={"a"}
        width={"28"}
        height={"28"}
        x={"0"}
        y={"0"}
        maskUnits={"userSpaceOnUse"}
        style={{
          maskType: 'alpha"'
        }}
      >
        <path fill={"#D9D9D9"} d={"M0 0h28v28H0z"}></path>
      </mask>

      <g mask={"url(#a)"}>
        <path
          fill={"#6D28D9"}
          d={
            "M9.625 20.709h8.75v-1.75h-8.75zm0-4.667h8.75v-1.75h-8.75zm-2.266 9.042q-.884 0-1.497-.613a2.04 2.04 0 0 1-.612-1.496V5.026q0-.884.612-1.497a2.04 2.04 0 0 1 1.497-.612h9.266l6.125 6.125v13.933q0 .884-.613 1.496a2.04 2.04 0 0 1-1.496.613zM15.75 9.917v-5.25H7.359a.34.34 0 0 0-.247.112.34.34 0 0 0-.112.247v17.949q0 .135.112.246a.34.34 0 0 0 .247.113h13.282q.135 0 .247-.113a.34.34 0 0 0 .112-.246V9.917z"
          }
        ></path>
      </g>
    </svg>
  );
}

export default Icon3Icon;
/* prettier-ignore-end */
